<template>
  <div class="Private">
    <Banner :privateNumObj="privateNumObj"></Banner>
    <Private></Private>
     <LoginDialog></LoginDialog>

  </div>
</template>

<script>
import bus from "@/bus";
import { mapMixin } from "@/util/mixin";
import { privateData } from "@/axios/private.js";

export default {
  name: "DataInfo",
  mixins: [mapMixin],
  data() {
    return {
      privateNumObj:null
    };
  },
  mounted(){
    this.privateDataFun()
  },
  methods:{
    async privateDataFun(){
      var res = await privateData()
  
      this.privateNumObj = res.data.data
      console.log( this.privateNumObj)
    }
  },
  components: {
    Banner: () => import("../components/Private/Banner/Banner.vue"),
    Private: () => import("../components/Private/Private.vue"),
     LoginDialog: () =>
      import("@/components/PublicComponents/LoginDialog/LoginDialog.vue"),
  
  },
 
};
</script>

<style lang="scss" scoped>
.Private {
  background: #F7F9FC;

  .DataInfo_content {
    // position: relative;
    // top: -60px;
    width: 1200px;
    margin: auto;
    border-radius: 10px;

    .DataInfo_content_top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: -72px;
      margin-bottom: 48px;
      // background: #fff;
      // border-radius: 4px;
    }
  }
}
</style>